{
  "feeCalculator": {
    "sections": {
      "inputs": "Entradas",
      "calculations": "Cálculos"
    },
    "tabs": {
      "tenantAndTransient": "Tarifas Inquilinos y Transeúntes",
      "annualFees": "Tarifas anuales"
    },
    "rateLabels": {
      "default": "Predet."
    },
    "inputs": {
      "aircraft": {
        "title": "Aeronave",
        "subtitle": "Aeronave para la que desea calcular tarifas. Usaremos la envergadura y longitud para calcular el área en los cálculos.",
        "makeModel": "Marca/Modelo",
        "dimensions": "Dimensiones"
      },
      "buffer": {
        "title": "Buffer",
        "subtitle": "Se añade un margen a cada extremo de las dimensiones. Ej: un margen de 2{{unit}} añade un total de 4{{unit}} al largo y 4{{unit}} a la envergadura."
      },
      "baseTenantRate": {
        "title": "Tarifa base inquilino",
        "subtitle": "Tarifa para calcular el precio mensual del arrendatario.",
        "label": "$ / {{unit}}² / mes"
      },
      "transientRate": {
        "title": "Tarifa de tránsito",
        "subtitle": "Tarifa para calcular el precio nocturno de tránsito.",
        "label": "$ / {{unit}}² / día"
      },
      "presets": {
        "title": "Preajustes",
        "subtitle": "Puedes añadir o editar tarifas predefinidas en Configuración > Estimación.",
        "label": "Tarifas"
      },
      "camFees": {
        "title": "Cuotas de mantenimiento de áreas comunes",
        "subtitle": "Cargos de mantenimiento de áreas comunes añadidos a la tarifa mensual del arrendatario. Puedes especificar un porcentaje o un cargo por {{unit}}².",
        "or": "O"
      }
    },
    "calculations": {
      "aircraftSquare": "Posición de aeronave {{unit}}",
      "aircraftSquareSubtitle": "Área ocupada por la aeronave. Se mide como envergadura x longitud.",
      "totalSquare": "Total en {{unit}} cuadrados",
      "totalSquareSubtitle": "Área ocupada por la aeronave + margen (si se proporciona).",
      "aircraftFee": "Tarifa de aeronave",
      "camFees": "Tarifas CAM",
      "totalFee": "Tarifa total",
      "tenantMonthly": "Arrendatario (mensual)",
      "transientDaily": "Tránsito (diario)"
    }
  }
}
